import React, { useMemo } from "react";
import PracticeTypeRow from "./practice-type-row.component";
import { PracticeTypeListItem } from "../../../../../common/types/tool.types";

interface PracticeTypesListProps {
  practicesList?: PracticeTypeListItem[];
  search?: string;
  onPracticeTypeSelectionChange?: (practiceId: string | number, practiceTypeId: string | number, isSelected: boolean) => void;
  isView?: boolean;
}

const PracticeTypesList: React.FC<PracticeTypesListProps> = ({
  practicesList = [],
  search = "",
  onPracticeTypeSelectionChange,
  isView = false,
}) => {
  const transformedPractices = useMemo(() => {
    if (!practicesList?.length) {
      return [];
    }

    return practicesList.map((practice) => ({
      practiceId: practice.value,
      practiceName: practice.label,
      practiceTypes: practice.practiceTypes?.map((practiceType) => ({
        practiceTypeId: practiceType.value,
        practiceTypeName: practiceType.label,
        practiceTypeIcon: undefined,
        isSelected: practiceType.selected,
      })) || [],
    }));
  }, [practicesList]);

  if (!transformedPractices.length) {
    return null;
  }

  return (
    <div id="practice-types-list" className="d-flex flex-column align-items-start">
      {transformedPractices.map((practice) => (
        <PracticeTypeRow
          key={practice.practiceId}
          practice={practice}
          search={search}
          onPracticeTypeSelectionChange={onPracticeTypeSelectionChange}
          isView={isView}
        />
      ))}
    </div>
  );
};

export default PracticeTypesList;

